import React from "react";
import PropTypes from "prop-types";
import { default as ReactSelect } from "react-select";

const MultiSelectDropdown = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: "none !important",
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box",
      height: "38px !important",
      margin: "0",
      borderRadius: "6px",
      outline: state.isFocused ? "2px solid #2684ff !important" : "",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      width: "0 !important",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "6px",
      fontSize: "14px",
      zIndex: 10,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 10,
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0",
      margin: "0",
      height: "36px !important",
    }),
    container: (base, state) => ({
      ...base,
      borderRadius: "6px !important",
      border: "1px solid #ccc",
      height: state.isFocused ? "38px" : base.height,
      outline: "none !important",
    }),
    placeholder: (base) => ({
      ...base,
      marginBottom: "2px",
    }),
    singleValue: (base) => ({
      ...base,
      marginBottom: "2px",
      fontSize: "14px !important",
    }),
  };

  const customFilter = (option, inputValue) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase());
  };

  if (props.allowSelectAll) {
    return (
      <span className="d-inline-block custom-input text-sm">
        <ReactSelect
          className="custom-checkbox-select text-sm"
          isDisabled={props.isDisabled}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          {...props}
          options={[props.allOption, ...props.options]}
          onChange={(selected) => {
            if (
              selected !== null &&
              selected.length > 0 &&
              selected[selected.length - 1].value === props.allOption.value
            ) {
              return props.onChange(props.options, props.drpIdentity);
            }
            return props.onChange(selected, props.drpIdentity);
          }}
        />
      </span>
    );
  }

  return (
    <ReactSelect
      {...props}
      styles={{
        ...customStyles,
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      filterOption={customFilter}
      menuPortalTarget={document.body}
      menuPosition="fixed"
    />
  );
};

MultiSelectDropdown.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

MultiSelectDropdown.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*",
  },
  Option: {
    label: "Select",
    value: "",
  },
};

export default MultiSelectDropdown;
